import { Action as VehiclesAction } from '../actions/vehicles';
import { Action as VehicleProfileAction } from '../actions/vehicle-profile';

const defaultState = {
  isFetching: false,
  vehicles: undefined,
  error: undefined,
};

export default function vehiclesReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case VehiclesAction.Vehicle.FetchVehiclesPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };
    case VehiclesAction.Vehicle.FetchVehiclesCompleted:
      return {
        ...state,
        isFetching: false,
        vehicles: body.vehicles || [],
      };
    case VehiclesAction.Vehicle.FetchVehiclesFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    // when vehicle gets added, add it to vehicles in state here too
    case VehicleProfileAction.VehicleProfile.CreateVehicleProfileCompleted:
      return {
        ...state,
        vehicles: [].concat(state.vehicles, body.vehicle),
      };

    // when vehicle gets updated, update it within vehicles here too
    case VehicleProfileAction.VehicleProfile.UpdateVehicleProfileCompleted:
      return {
        ...state,
        vehicles: state.vehicles.map(vehicle => (vehicle.guid === body.guid ? body : vehicle)),
      };

    // when vehicle gets removed, remove it from vehicles here too
    case VehicleProfileAction.VehicleProfile.DeleteVehicleProfileCompleted:
      return {
        ...state,
        vehicles: state.vehicles.filter(vehicle => vehicle.guid !== action.meta.vehicleGuid),
      };

    default:
      return state;
  }
}
